export const type_nutrition = 'nutrition';
export const type_trials = 'trials';
export const product_items_per_request = 8;
export const posts_per_request = 9;
export const homepage_posts_limit = 4;
export const vacancies_list_limit = 4;
export const flyers_limit = 6;

export const API = 'https://api-rc-uniferx.goodface.com.ua/api';
// export const API = 'https://api-uniferx.goodface.com.ua/api';
const API_RC = 'https://api-rc-uniferx.goodface.com.ua/api';
